angular.module('fg').controller('fgPropertyFieldOptionsController', [
  '$scope',
  function ($scope) {
    var ctrl = this;

    ctrl.addButtonText =
      $scope.field.type === 'tasklist' ? 'Add Task' : 'Add Option';

    ctrl.dragIndex = -1;
    ctrl.dropTargetIndex = -1;

    // Monitor for changes in the options array and ensure a
    // watch for every option value.
    // Watchers are deleted when removing options from the array.

    $scope.$watchCollection('field.options', function (options) {
      if (options) {
        angular.forEach(options, function (option) {
          if (!option.$_valueWatchFn) {
            option.$_valueWatchFn = $scope.$watch(function () {
              return option.value;
            }, handleValueChange);
          }
        });
      }
    });

    function handleValueChange(newValue, oldValue) {
      // Called by the watch collection
      // Ensure that when the selected value is changed, this
      // is synced to the field value.

      if (newValue !== oldValue) {
        if ($scope.multiple) {
          $scope.field.value[newValue] = $scope.field.value[oldValue];
          delete $scope.field.value[oldValue];
        } else {
          if (oldValue === $scope.field.value) {
            $scope.field.value = newValue;
          }
        }
      }
    }

    function newGuid() {
      function chunk(s) {
        var p = (Math.random().toString(16) + '000000000').substr(2, 8);
        return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
      }
      return chunk() + chunk(true) + chunk(true) + chunk();
    }

    ctrl.addOption = function () {
      if (!$scope.field.options) {
        $scope.field.options = [];
      }

      var optIndex;

      if ($scope.field.options.length === 0) {
        optIndex = 1;
      } else {
        // Find the maximum value across all options (not just the last one)
        var maxValue = $scope.field.options.reduce(function (max, o) {
          var n = parseInt(o && o.value, 10);
          return isNaN(n) ? max : Math.max(max, n);
        }, 0);
        optIndex = maxValue + 1;
      }

      var option = {
        value: optIndex.toString(),
        text: 'Option ' + optIndex,
        id: newGuid()
      };

      if ($scope.field.type === 'tasklist') {
        option.text = 'Task ' + optIndex;
      }

      $scope.field.options.push(option);

      var count = $scope.field.options.length;

      if (!$scope.multiple && count === 1) {
        $scope.field.value = option.value;
      }
    };

    ctrl.removeOption = function (index) {
      var options = $scope.field.options.splice(index, 1);

      if (options && options.length) {
        var option = options[0];

        if ($scope.multiple) {
          if ($scope.field.value[option.value] !== undefined)
            delete $scope.field.value[option.value];
        } else {
          if (
            option.value === $scope.field.value &&
            $scope.field.options.length
          ) {
            $scope.field.value = $scope.field.options[0].value;
          }

          option.$_valueWatchFn();
        }
      }
    };

    ctrl.moveOption = function (fromIndex, toIndex) {
      var options = $scope.field.options;
      if (
        fromIndex < 0 ||
        fromIndex >= options.length ||
        toIndex < 0 ||
        toIndex >= options.length ||
        fromIndex === toIndex
      ) {
        return;
      }
      var item = options.splice(fromIndex, 1)[0];
      options.splice(toIndex, 0, item);
    };

    ctrl.onDragEnd = function () {
      ctrl.dragIndex = -1;
      ctrl.dropTargetIndex = -1;
    };

    ctrl.onDrop = function (dropIndex) {
      if (ctrl.dragIndex === -1 || dropIndex === -1) {
        return;
      }

      var adjustedIndex =
        dropIndex > ctrl.dragIndex ? dropIndex - 1 : dropIndex;
      ctrl.moveOption(ctrl.dragIndex, adjustedIndex);
      ctrl.dragIndex = -1;
      ctrl.dropTargetIndex = -1;
    };
  }
]);
